import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Icon,
  Text,
  Th,
  Thead,
  Tr,
  Box,
  Grid,
  FormLabel,
  Select,
  Badge,
  Button,
  useToast,
  IconButton,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Table Components

// Data
import { ordersTableData } from "variables/general";
import GradientBorder from "components/GradientBorder/GradientBorder";
import CustomDateInput from "components/CustomField/CustomDateInput";
import { useLoader } from "components/Loader/loader";
import { FiEdit } from "react-icons/fi";
import { IoCodeSharp } from "react-icons/io5";
import TablesTableRow from "components/Tables/TablesTableRow";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { AiFillCloseCircle, AiFillRightCircle } from "react-icons/ai";
import useApiReq from "variables/apireq";
import { FaCheckCircle } from "react-icons/fa";
import { PagingControls } from "components/ui/pagination";
import { DeleteIcon, DownloadIcon } from "@chakra-ui/icons";
import InvoiceGenerator from "components/Invoice/invoice";

// Icons

function PaymentList() {
  const titleColor = "white";
  const toast = useToast({ position: "top" });
  const { setIsLoading, isLoading } = useLoader();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemcount, setItemCount] = useState(10);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(itemcount);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [type, setType] = useState();
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [modalIndex, setmodalIndex] = useState(null);
  const history = useHistory();

  const ChnageOpen = (index = null) => {
    setmodalIndex(index);
    setOpen(!isOpen);
  };
  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);

  const fetchPayments = async (data) => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "payment/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: data,
      });
      if (res.error) {
        setError(res.error);
        setData([]);
      } else {
        // Ensure response is an array before calling reverse
        const responseData = Array.isArray(res.response) ? res.response : [];
        const reversedData = [...responseData].reverse(); // Use spread to avoid mutating original
        setData(reversedData);
      }
    } catch (err) {
      setError(
        err?.message || err || "Failed to fetch payments. Please try again."
      );
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };
  const text = (child) => {
    return (
      <Text fontSize="sm" color="#fff" fontWeight="normal">
        {child}
      </Text>
    );
  };
  const badge = (child) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
        }}
      >
        <Badge
          borderRadius="10px"
          px="2"
          colorScheme="teal"
          color="white"
          variant="solid"
          h={{ base: "20px", md: "30px" }}
          fontSize={{ base: "sm", md: "md" }}
          textAlign="center"
          py={{ base: "4px", md: "4px" }}
        >
          {child}
        </Badge>
      </div>
    );
  };
  const edit = () => {
    return (
      <Button p="0px" bg="transparent" _hover="none" _active="none">
        <Icon as={FiEdit} color="gray.400" cursor="pointer" />
      </Button>
    );
  };
  const tag = (index) => {
    return (
      <Button
        p="0px"
        bg="transparent"
        _hover="none"
        _active="none"
        onClick={() => ChnageOpen(index)}
      >
        <Icon as={IoCodeSharp} color="gray.400" cursor="pointer" />
      </Button>
    );
  };

  const icon = ({ child, color, onclick = () => {} }) => {
    return (
      <Icon
        as={child}
        color={color}
        size={45}
        cursor="pointer"
        onClick={onclick}
      />
    );
  };
  useEffect(() => {
    if (
      startDate !== undefined &&
      endDate !== undefined &&
      type !== undefined
    ) {
      fetchPayments({
        start_date: startDate.toLocaleDateString(),
        end_date: endDate.toLocaleDateString(),
        status: type,
      });
    } else if (startDate !== undefined && endDate !== undefined) {
      fetchPayments({
        start_date: startDate.toLocaleDateString(),
        end_date: endDate.toLocaleDateString(),
      });
    } else if (type !== undefined) {
      fetchPayments({ status: type });
    } else {
      fetchPayments({});
    }
  }, [startDate, endDate, type]);

  const getOptimalData = (row, index) => {
    const data = {};
    data["Payment ID"] = text(index + 1);

    if (
      localStorage.getItem("group") === "Admin" ||
      localStorage.getItem("group") === "Publisher"
    ) {
      data["Advertiser"] = text(row.advertiser_name);
    }
    data["Paid At"] = text(new Date(row.created_at).toLocaleDateString());

    data["PR Number"] = text(row.prnumber);
    data["Analytics"] = row.analytics
      ? icon({
          child: FaCheckCircle,
          color: "green",
          onclick: () => {},
        })
      : icon({
          child: AiFillCloseCircle,
          color: "red",
          onclick: () => {},
        });
    data["facebook"] = row.facebook
      ? icon({
          child: FaCheckCircle,
          color: "green",
          onclick: () => {},
        })
      : icon({
          child: AiFillCloseCircle,
          color: "red",
          onclick: () => {},
        });

    data["Price"] = text(row.price);
    data["Fully Paid"] = row.fully_paid
      ? icon({
          child: FaCheckCircle,
          color: "green",
          onclick: () => {},
        })
      : icon({
          child: AiFillCloseCircle,
          color: "red",
          onclick: () => {},
        });
    data["Partial Paid"] = row.partial_paid
      ? icon({
          child: FaCheckCircle,
          color: "green",
          onclick: () => {},
        })
      : icon({
          child: AiFillCloseCircle,
          color: "red",
          onclick: () => {},
        });
    data["Paid amount"] = text(row.amount);

    data["Invoice"] = icon({
      child: DownloadIcon,
      color: "green",
      onclick: () => {
        const url = "/free-invoice.pdf"; // Path from public directory
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "invoice.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
    });

    return data;
  };
  const getHeaders = () => {
    const headers = [];
    headers.push("Payment ID");
    if (
      localStorage.getItem("group") === "Admin" ||
      localStorage.getItem("group") === "Publisher"
    ) {
      headers.push("Advertiser");
    }
    headers.push("Paid At");
    headers.push("PR Number");
    headers.push("Analytics");
    headers.push("Facebook");
    headers.push("Price");
    headers.push("Fully Paid");
    headers.push("Partial Paid");
    headers.push("Paid Amount");
    headers.push("Invoice");
    return headers;
  };

  useEffect(() => {
    fetchPayments({});
  }, []);

  useEffect(() => {
    setStart((currentPage - 1) * itemcount);
    setEnd(currentPage * itemcount);
  }, [currentPage, itemcount]);
  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {/* Authors Table */}
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader p="6px 0px 22px 0px">
          <Box w="100%">
            <Flex
              direction="row"
              justify="space-between"
              align="center"
              w="100%"
              mb="24px"
            >
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                Payment History
              </Text>
              <InvoiceGenerator />
            </Flex>
            <Grid
              templateColumns={{
                sm: "1fr",
                md: "1fr 1fr",
                lg: "1fr 1fr 1fr",
              }}
              gap={6}
              minW={{ sm: "100%", md: "100%" }}
              w="100%"
              mt="24px"
            >
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Payment Search From
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={startDate}
                    setSelectedDate={setStartDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Payment Search To
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={endDate}
                    setSelectedDate={setEndDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Type
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <Select
                    color={titleColor}
                    bg={{
                      base: "rgb(19,21,54)",
                    }}
                    border="transparent"
                    borderRadius="20px"
                    fontSize="sm"
                    size="lg"
                    w={{ base: "100%", lg: "100%" }}
                    maxW="100%"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    h="46px"
                    type="text"
                    placeholder="Select Type"
                    name="type"
                    sx={{
                      option: {
                        backgroundColor: "rgb(19,21,54)",
                        color: "white",
                      },
                    }}
                  >
                    <option value="PR">PR</option>
                    <option value="ANALYTIC PR">ANALYTIC PR</option>
                    <option value="CONTENT PR">CONTENT PR</option>
                  </Select>
                </GradientBorder>
              </Flex>
            </Grid>
          </Box>
        </CardHeader>
        <CardBody>
          <Table variant="simple" color="#fff">
            <Thead>
              <Tr my=".8rem" ps="0px" color="gray.400">
                {getHeaders().map((header) => {
                  return (
                    <Th
                      ps="0px"
                      color="gray.400"
                      fontFamily='"Oxygen",serif'
                      borderBottomColor="#56577A"
                      textAlign="center"
                    >
                      {header}
                    </Th>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody>
              {data?.length === 0 && (
                <Tr>
                  <Th colSpan="7" textAlign="center">
                    <Text fontSize="sm" color="gray.400" fontWeight="normal">
                      No data available
                    </Text>
                  </Th>
                </Tr>
              )}
              {data?.length > 0 &&
                data?.slice(start, end)?.map((row, index, arr) => {
                  return (
                    <TablesTableRow
                      data={getOptimalData(row, index)}
                      lastItem={index === arr?.length - 1}
                      setOpen={ChnageOpen}
                      isOpen={isOpen}
                      openIndex={modalIndex}
                      currentIndex={index}
                    />
                  );
                })}
            </Tbody>
          </Table>
        </CardBody>
        <Flex justify="space-between" my=".5rem">
          <PagingControls
            currentPage={currentPage}
            onGoToPage={(newPageNumber) => setCurrentPage(newPageNumber)}
            pageSize={itemcount}
            totalCount={data?.length || 0}
            totalCountDescription={"Payments"}
            showPageCount={true}
          />
          <Select
            w="80px"
            variant="outline"
            colorScheme="blackAlpha"
            bg="transparent"
            backgroundColor={"transparent"}
            backdropBlur={"10px"}
            textColor="white"
            borderColor="whiteAlpha.300"
            sx={{
              option: {
                backgroundColor: "rgb(19,21,54)",
                color: "white",
              },
            }}
            iconColor="white"
            onChange={(e) => {
              setItemCount(e.target.value);
            }}
            value={itemcount}
          >
            <option value="10" selected>
              10
            </option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>
        </Flex>
      </Card>
    </Flex>
  );
}

export default PaymentList;
